import { render } from "./MatchingRetrievalStart.vue?vue&type=template&id=b8e58db2&scoped=true&ts=true&lang=pug"
import script from "./MatchingRetrievalStart.vue?vue&type=script&lang=ts"
export * from "./MatchingRetrievalStart.vue?vue&type=script&lang=ts"

import "./MatchingRetrievalStart.vue?vue&type=style&index=0&id=b8e58db2&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8e58db2"]])

export default __exports__